import React from 'react';
import { Home } from 'lucide-react';
import PVSPageLayout from './PVSPageLayout';

const CALOR_CONTACTS = [
  {
    name: 'Jordan Tree',
    jobTitle: 'Pressure Systems Standards & Quality Manager',
    telephone: '1234',
    email: 'JTree@calor.co.uk',
  },
  {
    name: 'Wayne Hancock',
    jobTitle: 'Tank and Equipment Supply Manager',
    telephone: '07891 425862',
    email: 'WHancock@calor.co.uk',
  },
  {
    name: 'Denzil Oliver',
    jobTitle: 'Pressure Systems Engineer (National Engineering)',
    telephone: '1234',
    email: 'DOliver@calor.co.uk',
  },
];

const CalorLineOfContact = ({ onBack }) => (
  <PVSPageLayout className="p-8">
    <div className="max-w-2xl mx-auto">
      <div className="pvs-glass p-6">
        <div className="flex justify-between items-center gap-4 mb-6">
          <h1 className="text-2xl font-bold text-white">Calor Line of Contact</h1>
          <button
            type="button"
            onClick={onBack}
            className="flex items-center justify-center w-12 h-12 flex-shrink-0 pvs-glass pvs-glass-hover"
            title="Back"
          >
            <Home className="w-6 h-6" stroke="url(#icon-two-tone)" />
          </button>
        </div>
        <div className="space-y-6">
          {CALOR_CONTACTS.map(({ name, jobTitle, telephone, email }) => (
            <div key={email} className="border-b border-pvs-border pb-6 last:border-0 last:pb-0">
              <h2 className="text-lg font-semibold text-white mb-4">{name}</h2>
              <dl className="space-y-3">
                <div>
                  <dt className="text-sm text-pvs-text-muted mb-1">Job Title</dt>
                  <dd className="text-white">{jobTitle}</dd>
                </div>
                <div>
                  <dt className="text-sm text-pvs-text-muted mb-1">Telephone</dt>
                  <dd className="text-white">
                    <a href={`tel:${telephone.replace(/\s/g, '')}`} className="hover:text-pvs-accent">
                      {telephone}
                    </a>
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-pvs-text-muted mb-1">Email</dt>
                  <dd className="text-white">
                    <a href={`mailto:${email}`} className="hover:text-pvs-accent">
                      {email}
                    </a>
                  </dd>
                </div>
              </dl>
            </div>
          ))}
        </div>
      </div>
    </div>
  </PVSPageLayout>
);

export default CalorLineOfContact;
